import { useEffect, useState } from "react";
import styles from "./FormBuilderPage.module.css";
import FormBuilder from "../../components/FormBuilder/FormBuilder";
import CopyRight from "../../components/CopyRight/CopyRight";
import { useNavigate } from "react-router-dom";
import FormDetails from "../../sections/FormDetails/FormDetails";
import DesignForm from "../../sections/DesignForm/DesignForm";

const FormBuilderPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();

  // 👇 scroll to top whenever currentStep changes
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" }); // optional: use smooth scroll
    }, 0);
  }, [currentStep]);

  const steps = [
    { id: 1, label: "Form Details" },
    { id: 2, label: "Design form" },
    { id: 3, label: "Style your form" },
    { id: 4, label: "Preview" },
  ];

  const stepContents = [
    <div className={styles.card}>
      <FormDetails goNext={() => setCurrentStep(1)} />
    </div>,
    <div className={styles.card}><DesignForm/></div>,
    <div className={styles.card}>🎨 Style Form Content Here</div>,
    <div className={styles.card}>👁️ Preview Content Here</div>,
  ];

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      <div className={styles.pageWrapper}>
        <div className={styles.topBar} onClick={handleBackClick}>
          <span className={styles.backArrow}>←</span>
          <span className={styles.title}>Student application form Builder</span>
        </div>

        <div className={styles.formBuilderWrapper}>
          <FormBuilder
            steps={steps}
            stepContents={stepContents}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        </div>
      </div>

      <div className={styles.copyRightContainer}>
        <CopyRight />
      </div>
    </>
  );
};

export default FormBuilderPage;
